import { useState, type FormEvent } from 'react'
import { Button, Input } from '@/components/ds2'
import { parseRateAmount, setRateMessage } from './rowActions'

interface SetRateActionProps {
    loadNumber: string
    label: string
    onSend: (message: string) => void
}

/**
 * "Set rate" on a load with no Original Rate: a small amount field whose Save asks the agent to set it, so its edit card
 * shows the change for approval. Nothing is written from here.
 */
export const SetRateAction = ({ loadNumber, label, onSend }: SetRateActionProps) => {
    const [open, setOpen] = useState(false)
    const [value, setValue] = useState('')
    const amount = parseRateAmount(value)
    const valid = amount !== null

    const save = (event: FormEvent) => {
        event.preventDefault()
        if (amount === null) return
        onSend(setRateMessage(loadNumber, amount))
        setOpen(false)
        setValue('')
    }

    if (!open) {
        return (
            <Button size="sm" variant="secondary" onClick={() => setOpen(true)}>
                {label}
            </Button>
        )
    }
    return (
        <form className="flex items-center gap-1.5" onSubmit={save}>
            <div className="w-28">
                <Input
                    variant="outlined"
                    inputMode="decimal"
                    placeholder="$ amount"
                    aria-label={`Original Rate for #${loadNumber}`}
                    value={value}
                    autoFocus
                    onChange={(e) => setValue(e.target.value)}
                />
            </div>
            <Button size="sm" type="submit" disabled={!valid}>
                Save
            </Button>
            <Button size="sm" variant="ghost" type="button" onClick={() => setOpen(false)}>
                Cancel
            </Button>
        </form>
    )
}
